import React, { useState } from 'react';
import { NameScreen } from './screens/NameScreen';
import { AddressScreen } from './screens/AddressScreen';
import { NationalIdScreen } from './screens/NationalIdScreen';
import { PoliticalExposureScreen } from './screens/PoliticalExposureScreen';
import { PersonalInfoReview } from './screens/PersonalInfoReview';
interface PersonalInfoJourneyProps {
  onComplete: (data: any) => void;
  onExit: () => void;
}
export function PersonalInfoJourney({
  onComplete,
  onExit
}: PersonalInfoJourneyProps) {
  const [step, setStep] = useState(0);
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    address: '',
    city: '',
    zipCode: '',
    nationalId: '',
    isPoliticallyExposed: ''
  });
  const updateField = (field: string, value: string) => {
    setFormData(prev => ({
      ...prev,
      [field]: value
    }));
  };
  const nextStep = () => setStep(prev => prev + 1);
  const prevStep = () => {
    if (step === 0) {
      onExit();
    } else {
      setStep(prev => prev - 1);
    }
  };
  const goToStep = (stepIndex: number) => setStep(stepIndex);
  const handleConfirm = () => {
    onComplete(formData);
  };
  return <div className="h-full" data-id="element-19">
      {/* Progress bar could go here if needed, but keeping it clean for now */}

      {step === 0 && <NameScreen firstName={formData.firstName} lastName={formData.lastName} onChange={updateField} onNext={nextStep} onBack={prevStep} data-id="element-20" />}

      {step === 1 && <AddressScreen address={formData.address} city={formData.city} zipCode={formData.zipCode} onChange={updateField} onNext={nextStep} onBack={prevStep} data-id="element-21" />}

      {step === 2 && <NationalIdScreen nationalId={formData.nationalId} onChange={updateField} onNext={nextStep} onBack={prevStep} data-id="element-22" />}

      {step === 3 && <PoliticalExposureScreen isPoliticallyExposed={formData.isPoliticallyExposed} onChange={updateField} onNext={nextStep} onBack={prevStep} data-id="element-23" />}

      {step === 4 && <PersonalInfoReview data={formData} onConfirm={handleConfirm} onBack={prevStep} onEdit={goToStep} data-id="element-24" />}
    </div>;
}